var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCancel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.356,
    height: 18.358,
    viewBox: "0 0 18.356 18.358",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "cancel_copy",
    "data-name": "cancel copy",
    d: "M60.266,58.9h.5a8.28,8.28,0,0,1,.744.594c2.092,2.078,4.169,4.165,6.256,6.247.1.1.2.192.365.346a2.9,2.9,0,0,1,.257-.346q3.123-3.13,6.252-6.252a8.276,8.276,0,0,1,.744-.594h.5a7.128,7.128,0,0,1,.725.562c.866.847.856,1.24-.009,2.106l-6.2,6.2c-.1.1-.192.2-.318.332.14.122.253.211.356.314Q73.628,71.6,76.817,74.8a1.038,1.038,0,0,1,.009,1.675c-.1.1-.2.2-.3.3a1.069,1.069,0,0,1-1.778-.009q-3.173-3.18-6.354-6.354c-.1-.1-.2-.192-.318-.3-.112.108-.211.2-.3.285l-6.331,6.331a3.911,3.911,0,0,1-.285.271.938.938,0,0,1-1.277,0c-.356-.342-.655-.744-.978-1.118v-.5a8.279,8.279,0,0,1,.594-.744c2.078-2.092,4.165-4.169,6.247-6.256.1-.1.192-.2.332-.346a3.606,3.606,0,0,1-.328-.271q-3.116-3.109-6.223-6.228a9.106,9.106,0,0,1-.618-.772v-.5A3.388,3.388,0,0,1,60.266,58.9Z",
    transform: "translate(-58.9 -58.9)",
    fill: "#012251"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.7fc6439a.svg";
export { ForwardRef as ReactComponent };